import { Injectable } from '@angular/core';
import { CanActivate,  UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Guard1Guard implements CanActivate {
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      let rol = localStorage.getItem('rol');

      if(rol==="1"){
        return true;
      }
      return false;

  }

}
